import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import SiteAssistant from "./components/SiteAssistant";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Courses from "./pages/Courses";
import Subscribe from "./pages/Subscribe";
import Dashboard from "./pages/Dashboard";
import Contact from "./pages/Contact";
import Schedule from "./pages/Schedule";
import GroupStudy from "./pages/GroupStudy";
import Profile from "./pages/Profile";

import PurchaseHistory from "./pages/PurchaseHistory";
import ThankYou from "./pages/ThankYou";

function AppLayout({ children, showHeader = true, showFooter = true }) {
  return (
    <div className="min-h-screen flex flex-col">
      {showHeader && <Header />}
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Auth pages without header/footer */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          {/* Public pages with header/footer */}
          <Route path="/" element={
            <AppLayout>
              <Landing />
            </AppLayout>
          } />
          <Route path="/courses" element={
            <AppLayout>
              <Courses />
            </AppLayout>
          } />
          <Route path="/subscribe" element={
            <AppLayout>
              <Subscribe />
            </AppLayout>
          } />
          <Route path="/pricing" element={
            <AppLayout>
              <Subscribe />
            </AppLayout>
          } />
          <Route path="/about" element={
            <AppLayout>
              <Landing />
            </AppLayout>
          } />
          <Route path="/contact" element={
            <AppLayout>
              <Contact />
            </AppLayout>
          } />
          <Route path="/thank-you" element={
            <AppLayout>
              <ThankYou />
            </AppLayout>
          } />
          <Route path="/schedule" element={
            <AppLayout>
              <Schedule />
            </AppLayout>
          } />
          <Route path="/study-rooms" element={
            <AppLayout>
              <GroupStudy />
            </AppLayout>
          } />
          
          {/* Protected pages */}
          <Route path="/profile" element={
            <ProtectedRoute>
              <AppLayout>
                <Profile />
              </AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <AppLayout showFooter={false}>
                <Dashboard />
              </AppLayout>
            </ProtectedRoute>
          } />
          <Route path="/purchases" element={
            <ProtectedRoute>
              <AppLayout>
                <PurchaseHistory />
              </AppLayout>
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster position="top-right" />
        <SiteAssistant />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
